<template>
    <div id="wrapper">
      <Sidebar></Sidebar>
      <!-- Content Wrapper -->
      <div id="content-wrapper" class="d-flex flex-column">

        <!-- Main Content -->
        <div id="content">

          <Topbar></Topbar>
          <!-- Begin Page Content -->
          <div class="container-fluid">

            <!-- Page Heading -->
            <router-link :to="{ name: 'Home'}" > CRCB Control Panel</router-link> >
            <span>內容管理</span>
            <h1 class="h3 mb-2 mt-2 text-gray-800">內容管理</h1>

            <Msg :message="message" :is_error="is_error"></Msg>

            <div class="text-center" v-if="loading" >
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>  

            <!-- DataTales -->
            <div class="card shadow mb-4" v-if="!loading">
                <div class="card-header py-3">
                <button type="button" class="btn btn-primary" v-on:click="Add">新增</button>
                </div>
                <div class="card-body">
                    <div class="form-group row">
                        <label for="section" class=" col-form-label" style="padding-left:0.75em;"><b>單元:</b></label>
                        <div class="col-sm-2">
                            <select class="custom-select" v-model="item.selected" @change="Switch();Get()"> 
                                <option v-for="(item) in category" :key="item.id" :value="item.id" >{{item.data.name}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="section" class=" col-form-label" style="padding-left:0.75em;"><b>類別:</b></label>
                        <div class="col-sm-2">
                            <select class="custom-select" v-model="item.list_selected" @change="Get()"> 
                                <option value="all" >All</option>
                                <option v-for="(item) in list" :key="item.id" :value="item.id" >{{item.name}}</option>
                            </select>
                        </div>
                    </div>

                    <div class="table-responsive">
                      <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0">
                        <thead>
                          <tr>
                            <th width="10%">日期</th>
                            <th>類別</th>
                            <th width="50%">標題</th>
                            <th style='min-width:150px'>功能</th>
                            <th width="7%" class="order" >排序</th>
                          </tr>
                        </thead>
                        <draggable tag="tbody" v-model="datas" group="people" @start="drag=true" @end="drag=false;Update()" :disabled="disabled" >
                          <tr v-for="(data) in datas" :key="data.id">
                            <td>{{data.data.date}}</td>
                            <td>{{data.data.category_name}}</td>
                            <td>{{data.data.title}}</td>
                            <td>
                              <button type="button" class="btn btn-primary" v-on:click="Edit(data.id)">編輯</button>
                              <button type="button" class="btn btn-danger" v-on:click="Delete(data.id)">刪除</button>
                            </td>
                            <td class="order">
                              <label style="cursor:grab"><i class="fas fa-sort fa-lg" :class="{'disabled-order':disabled}"></i></label>
                            </td>
                          </tr>
                        </draggable>
                 
                      </table>
                    </div>


                </div>
            </div>

          </div>
          <!-- /.container-fluid -->

        </div>
        <!-- End of Main Content -->

        <Footer></Footer>

      </div>
      <!-- End of Content Wrapper -->
    </div>
</template>

<script>
import {fb, db } from '../firebase'
import Draggable from 'vuedraggable'
export default {
  name: 'User',
  components: {
    Draggable
  },
  data () {
    return {
        datas:[],
        show:[],
        category:[],
        list:[],
        item:{
            selected:'',
            list_selected:''
        },
        disabled:false,
        loading:true,
        message:'',
        is_error:false
    }
  },
  mounted () {
    this.GetCatgory();
  },
  methods: {
    Switch() {
      this.list = this.category.find(x => x.id === this.item.selected).data.list;
      this.item.list_selected = 'all';
    },
    GetCatgory() {
        db.collection("category").get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                var data = {"id": doc.id, "data": doc.data()};
                
                this.category.push(data);
            });
            this.category.sort( (d1, d2) => d1.data.order - d2.data.order);
            this.item.selected = this.category[0].id;
            this.item.list_selected = 'all';
            this.Switch();
            this.Get();
        });
    },
    Get(){
        var vm = this;
        this.datas = [];
        // 取得列表
        db.collection("news").where("selected", "==", this.item.selected).get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                // doc.data() is never undefined for query doc snapshots


                var item = doc.data();
                if ( this.list.find(x=>x.id == item.list_selected) ) item.category_name = this.list.find(x=>x.id == item.list_selected).name;
                else item.category_name = ''
                
                var data = {"id": doc.id, "data": item};

                if ( this.item.list_selected == 'all'|| this.item.list_selected == item.list_selected)
                    this.datas.push(data);

            });

            this.datas.sort( (d1, d2) => d2.data.order - d1.data.order);
              
            // this.datas.forEach(function(value, index, array){
            //   console.log(vm.datas[index].data.title + '-' + vm.datas[index].data.order);
            // });

            this.loading = false;
            if ( vm.item.list_selected != 'all') vm.disabled = true;
            else vm.disabled = false;

            if ($.fn.DataTable.isDataTable('#dataTable')) {
              $('#dataTable').dataTable().fnClearTable();
              $('#dataTable').dataTable().fnDestroy();
            }

            vm.EnableTable();

        });

       
    },
    Test(){
    },
    Add() {
      this.$router.push({name: 'NewsAdd'}); 
    },
    Edit(id) {
      this.$router.push({name: 'NewsEdit', params: { id: id }});
    },
    Delete(id) {
      if ( confirm("確定要刪除?") ) {
        db.collection("news").doc(id).delete()
        .then(() => {
            alert("刪除成功!");
            this.Get();
        }).catch((error) => {
            console.log("Error getting document:", error);
        });
      }
    },
    Update() {

      this.disabled = true;
      this.Beforesend();
      var batch = db.batch();

      var total = this.datas.length;
      this.datas.forEach(function(value, index, array){
        // Update the population of 'SF'
        var sfRef = db.collection("news").doc(value.id);
        batch.update(sfRef, {"order": total});
        total--;
      });

      batch.commit()
      .then(() => {
        this.disabled = false;
        this.message = "排序更新成功";
        this.is_error = false;
        this.Aftersend();
      }).catch(()=>{
        this.disabled = false;
        this.message = "排序更新失敗";
        this.is_error = true;
        this.Aftersend();
      });
    }
  }
}
</script>
<style scoped>
.title, .item{
    border-bottom:1px solid #e3e6f0
}
.title {
    font-weight: 700;
}
th,td {
  border-top:1px solid #e3e6f0 !important;
  border-bottom: 0px;
  border-left: 0px;
  border-right: 0px;
}
th:last-child,td:last-child {
  border-right:1px solid #e3e6f0 !important;
}
.disabled-order{
  color:#b1b1b1 !important;
  cursor: not-allowed;
}
</style>


// WEBPACK FOOTER //
// src/components/News.vue